import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

const HookFormCheckbox = ({
  name,
  label,
  helperText,
  formMethods,
  onChange: onChangeHandler = () => {},
  deps = [],
  disabled = false,
  ...props
}) => {
  const {
    control,
    trigger,
    formState: { errors },
  } = formMethods;
  const errorMessage = errors[name]?.message;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          sx={{ alignItems: 'flex-start', m: 0, gap: 1 }}
          disabled={disabled}
          control={
            <Checkbox
              id={name}
              name={name}
              size="small"
              disabled={disabled}
              checked={!!value}
              onChange={event => {
                const { checked } = event.target;
                deps.forEach(dep => trigger(dep));
                onChange(checked);
                onChangeHandler(checked);
              }}
              sx={{ py: 0.25 }}
              {...props}
            />
          }
          label={
            <Stack spacing={0.25}>
              <Typography variant="body2" sx={{ color: disabled ? '#6B7280' : '#F3F4F6' }}>
                {label || name}
              </Typography>
              {errorMessage || helperText ? (
                <Typography
                  variant="caption"
                  sx={{
                    color: errorMessage ? 'error.main' : disabled ? '#6B7280' : '#9CA3AF',
                  }}>
                  {errorMessage || helperText}
                </Typography>
              ) : null}
            </Stack>
          }
        />
      )}
    />
  );
};

export default HookFormCheckbox;
